import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { getJahisNsipsStats } from '../../../../apis/jahisNsipsMatching'
import { GlobalState } from '../../../../stores/reducer'
import { queryKeys } from '../../../../shared'

/**
 * JAHIS-NSIPS突合統計を取得する Query hook
 *
 * 指定期間の統計情報（一致率、フィールド別一致率）を取得する。
 *
 * @param startDate - 開始日（YYYY-MM-DD）
 * @param endDate - 終了日（YYYY-MM-DD）
 * @param pharmacyId - 薬局ID（本部アカウントのみ指定可能）
 */
export const useJahisNsipsStatsQuery = (
  startDate: string | undefined,
  endDate: string | undefined,
  pharmacyId?: string
) => {
  const isLoggedIn = useSelector((state: GlobalState) => state.isLoggedIn)

  return useQuery({
    queryKey: queryKeys.jahisNsipsMatching.stats(
      startDate || '',
      endDate || '',
      pharmacyId
    ),
    queryFn: async () => {
      const { data } = await getJahisNsipsStats({
        start_date: startDate!,
        end_date: endDate!,
        ...(pharmacyId ? { pharmacy_id: pharmacyId } : {}),
      })
      return data
    },
    enabled: isLoggedIn && !!startDate && !!endDate,
    staleTime: 5 * 60 * 1000, // 5分間キャッシュを有効に
  })
}
